import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass.ts";
import Slider from "../utils/slider";


class CollapsePartnerLogo extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	init () {
		let getSwiper = Array.prototype.slice.call(this.selector.querySelectorAll('.swiper'))
		if(getSwiper.length > 0 ){
			getSwiper.forEach(async (swip)=>{
				new Slider(swip)
				// new IntersectionObserver((entries, observer) => {
				// 	INIT_SWIPER.init();
				// }).observe(this.selector);
			})
		}

	}
}

export default CollapsePartnerLogo;

